import { types as actions } from '../actions';
const defaultState = {
  isAuthenticated: false,
  loginError: false,
  account: {},
  username: null,
  forgotPasswordCompleted: false,
  tokenValid: true,
  resendVerifyCompleted: false,
  checkingSSO: false,
  authenticating: false,
  sso: {}
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.LOG_IN:
      return {
        ...state,
        loginError: false,
        authenticating: true,
        username: action.username
      };
    case actions.LOGIN_ERROR:
      return {
        ...state,
        checkingSSO: false,
        authenticating: false,
        loginError: true
      };
    case actions.LOGGED_IN:
      if(action.token){
        let conductor_auth_token = {};
        try {
          conductor_auth_token = JSON.parse(localStorage.getItem('conductor_auth_token')) || {};
        } catch (e) { }
        conductor_auth_token.access_token = action.token;
        localStorage.setItem('conductor_auth_token', JSON.stringify(conductor_auth_token));
      }
      return {
        ...state,
        isAuthenticated: true,
        loginError: false,
        authenticating: false,
      };
    case actions.READ_TOKEN_ERROR:
    case actions.LOGGED_OUT:
      return defaultState;
    case actions.FORGOT_PASSWORD_COMPLETED:
      return {
        ...state,
        forgotPasswordCompleted: true
      }
    case actions.RESET_PASSWORD_COMPLETED:
      return {
        ...state,
        resetPasswordCompleted: true
      }
    case actions.VERIFY_PASSWORD_TOKEN_COMPLETED:
      return {
        ...state,
        tokenValid: action.status
      }
    case actions.RESEND_VERIFY_COMPLETED:
      return {
        ...state,
        resendVerifyCompleted: true
      }
    case actions.RESEND_VERIFY_HIDE_MODAL:
      return {
        ...state,
        resendVerifyCompleted: false
      }
    case actions.CHECK_SSO:
      localStorage.setItem('email', action.email);
      return {
        ...state,
        checkingSSO: true
      }
    case actions.CHECKED_SSO:
      if(action.url){
        localStorage.setItem('sso', 1)
        document.location.href = action.url
      }
      return {
        ...state,
        sso: false,
        checkingSSO: false
      }
    case actions.ERROR:
      return {
        ...state,
        checkingSSO: false,
        authenticating: false
      }
    case actions.RESET_LOGIN:
      return {
        ...state,
        loginError: false,
        username: null
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/auth/index.js